import {Injectable, OnDestroy, OnInit} from '@angular/core';
import {ParentAPIService} from '../parent.api.service';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {CrystalclearMetricsBackUrl} from "../config/crystalclear-metrics-back-url";
import {ClearingDataTrendMetricsRequest} from "../../model/metrics/clearing-data-trend-metrics-request";
import {ClearingScorecard} from "../../model/metrics/clearing-scorecard";
import {RecordResult} from "../../model/api/record-result";
import {RecordRequest} from "../../model/api/record-request";
import {ExchangeVolumePerDateTime} from "../../model/metrics/exchange-volume-per-date-time";

@Injectable({
  providedIn: 'root'
})
export class MetricsService extends ParentAPIService implements OnInit, OnDestroy {

  constructor(http: HttpClient,
              private toastService: ToastService) {

    super(http);
  }

  ngOnInit(): void {
  }


  ngOnDestroy() {
  }

  public getClearingStatusList(requests: RecordRequest): Observable<RecordResult<ClearingScorecard>> {
    return this.post(CrystalclearMetricsBackUrl.GET_CLEARING_STATUS_METRICS, requests);
  }

  public getClearingDataTrendMetricsList(requests: ClearingDataTrendMetricsRequest): Observable<RecordResult<ExchangeVolumePerDateTime>> {
    return this.post(CrystalclearMetricsBackUrl.GET_CLEARING_DATA_TREND_METRICS, requests);
  }

}
